import React from "react";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/styles";
import useStyles from "./styles";
import { Grid } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DataTable from "../../DataTable";
import { URL_ARTICLES_SUGGESTIONS, URL_EXERCISES_SUGGESTIONS } from "../../../utils/UrlConstants";
import { convert } from "../../../utils/DateUtils";
import { getThumbnail } from "../../../utils/YoutubeUtils";

const styles = useStyles;

class ArticleSuggestionsSelectionDialog extends React.Component {

  constructor(props) {
    super(props);

    const { classes } = props;

    this.state = {
      entity : "patients.detail.articles.suggestions",
      enableButton : false,
      api : URL_ARTICLES_SUGGESTIONS,
      columns : [
        {
          name: 'description',
          options: {
            customBodyRender: (value => {
              return (<div dangerouslySetInnerHTML={{ __html: value }}/>)
            })
          },
        },
        {
          name: 'patient',
          options : {
            sort: false,
            customBodyRender: (value => {
              return (value.fullName)
            })
          },
        },
      ],
      rowsSelected : []
    };
    this.baseState = this.state;
    this.onClose = this.onClose.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onRowsSelect = this.onRowsSelect.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.open === true && this.props.open === false) {
      //console.log('reopening');
      this.setState(this.baseState);
    }
  }

  onClose() {
    const { onClose } = this.props;
    onClose();
  }

  onSelect(){
    const {rowsSelected} = this.state;
    if (this.props.onSelect){
      this.props.onSelect(rowsSelected[0]);

      // call the api
      // notify
      // close
    }
  }

  onRowsSelect(rowsSelected){
    console.log('rowsSelected : ' + JSON.stringify(rowsSelected));
    this.setState({
      rowsSelected : rowsSelected,
      enableButton : (rowsSelected.length > 0)
    })
  }

  render (){
    const { classes, t, open, onClose, id } = this.props;
    const { enableButton, entity, columns } = this.state;
    let {api} = this.state;

    api = api.replace(":id", id);

    return (
      <>
          <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title" disableBackdropClick={true} fullWidth={true} maxWidth="xl">
            <DialogTitle id="form-dialog-title">{t(entity+'.title')}</DialogTitle>
            <DialogContent>
              <Grid container spacing={4}>
                <Grid item xs={12}>
                  <DataTable entity={entity} api={api} columns={columns} disableToolbarSelect={true} onRowsSelect={this.onRowsSelect} selectedProperty={"description"}/>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button autoFocus onClick={onClose}>
                {t("buttons.cancel")}
              </Button>
              <Button onClick={this.onSelect} color="primary" disabled={!enableButton}>
                <div>{t("buttons.select")}</div>
              </Button>
            </DialogActions>
          </Dialog>
        </>
    );

  }
}

export default withTranslation()(withStyles(styles)(ArticleSuggestionsSelectionDialog));